import type { LabelAlignment } from '../../range/types/range-legend.internal.js';
import { LABEL_ALIGNMENT } from '../constants.js';

export const getLabelAlignment = (
  hasMaxValue: boolean,
  isLastItem: boolean,
  isVertical = false,
): LabelAlignment => {
  if (isVertical && isLastItem && !hasMaxValue) {
    return LABEL_ALIGNMENT.Start;
  }
  if (isLastItem && !hasMaxValue) {
    return LABEL_ALIGNMENT.End;
  }

  return LABEL_ALIGNMENT.Center;
};
